import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { CENTRAL_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetCentralInfo extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = CENTRAL_URL;

  constructor(token) {
    super();
    const paramList = [token];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
